export enum ErrorLevel {
  error = 'error',
  information = 'information',
}

export interface IErrorResponse {
  statusCode: number | undefined;
  errorCode: number | undefined;
  errorLevel: ErrorLevel | undefined;
  errorMessage: string | undefined;
}
